// Organization-level feature flags and modes
export var FeatFlagEnrollmentScheduleSelectionMode;
(function (FeatFlagEnrollmentScheduleSelectionMode) {
    FeatFlagEnrollmentScheduleSelectionMode["EXISTING_ONLY"] = "existing_only";
    FeatFlagEnrollmentScheduleSelectionMode["INLINE_ONLY"] = "inline_only";
    FeatFlagEnrollmentScheduleSelectionMode["INLINE_AND_EXISTING"] = "inline_and_existing";
})(FeatFlagEnrollmentScheduleSelectionMode || (FeatFlagEnrollmentScheduleSelectionMode = {}));
export var FeatFlagCalendarSessionTitleViewMode;
(function (FeatFlagCalendarSessionTitleViewMode) {
    FeatFlagCalendarSessionTitleViewMode["INSTRUCTOR_NAME"] = "instructor_name";
    FeatFlagCalendarSessionTitleViewMode["CUSTOMER_NAMES"] = "customer_names";
    FeatFlagCalendarSessionTitleViewMode["SCHEDULE_NAME"] = "schedule_name";
})(FeatFlagCalendarSessionTitleViewMode || (FeatFlagCalendarSessionTitleViewMode = {}));
// Session status types for color legend configuration
export var CalendarSessionColorStatus;
(function (CalendarSessionColorStatus) {
    CalendarSessionColorStatus["TRIAL"] = "trial";
    CalendarSessionColorStatus["CANCELED"] = "canceled";
    CalendarSessionColorStatus["EMPTY"] = "empty";
    CalendarSessionColorStatus["CONFIRMED"] = "confirmed";
    CalendarSessionColorStatus["REPOSITION"] = "reposition";
    CalendarSessionColorStatus["EXPIRED_ENROLLMENT"] = "expired_enrollment";
})(CalendarSessionColorStatus || (CalendarSessionColorStatus = {}));
// Default color legend values
export const DEFAULT_CALENDAR_SESSION_COLOR_LEGEND = {
    [CalendarSessionColorStatus.TRIAL]: "#facc15", // yellow-400
    [CalendarSessionColorStatus.CANCELED]: "#ef4444", // red-500
    [CalendarSessionColorStatus.EMPTY]: "#ef4444", // red-500
    [CalendarSessionColorStatus.CONFIRMED]: "#22c55e", // green-500
    [CalendarSessionColorStatus.REPOSITION]: "#3b82f6", // blue-500
    [CalendarSessionColorStatus.EXPIRED_ENROLLMENT]: "#f97316", // orange-500
};
// Schedule overlap validation mode
export var FeatFlagScheduleOverlapValidation;
(function (FeatFlagScheduleOverlapValidation) {
    FeatFlagScheduleOverlapValidation["BLOCK"] = "block";
    FeatFlagScheduleOverlapValidation["ALLOW"] = "allow";
})(FeatFlagScheduleOverlapValidation || (FeatFlagScheduleOverlapValidation = {}));
// Default enrollment status filter values
export const DEFAULT_CALENDAR_SESSION_ENROLLMENT_STATUS_FILTER = {
    defaultStatuses: ["ACTIVE", "PENDING"],
};
//# sourceMappingURL=FeatureFlags.js.map